import { setTimeoutFallback } from './async'
import ga from './ga'

const setGATracker = () => {
  return setTimeoutFallback(
    resolve => {
      ga(tracker => {
        resolve(tracker.get('clientId'))
      })
    },
    resolve => {
      resolve(null)
    },
    1000
  )
}

export default setGATracker
